import { Component, Inject, InjectionToken, OnInit } from '@angular/core';
import { IInjectedElementDtype } from '../../../models/InjectedElementDtype';
import { SHARED_MODULES } from '../../../../shared.';
import { PhIconComponent } from '../../ph-icon/ph-icon.component';

export const ELEMENT = new InjectionToken<any>('element', {
	providedIn: 'root',
	factory: () => 'element'
});

type DeadlineDateDtypeElement = {
	is_overdue: boolean;
	value: string;
	is_time_tracker_enabled: boolean;
}

@Component({
    selector: 'app-deadline-date-dtype',
    templateUrl: './deadline-date-dtype.component.html',
    styleUrls: ['./deadline-date-dtype.component.scss'],
	imports: [SHARED_MODULES, PhIconComponent],
    standalone: true
})
export class DeadlineDateDtypeComponent implements OnInit {

	element: DeadlineDateDtypeElement;

	constructor(
		@Inject(ELEMENT) private elementInjected: IInjectedElementDtype<DeadlineDateDtypeElement>
	) {}

	ngOnInit(): void {
		this.element = { ...this.elementInjected.element };
	}
}
